// Validace formuláře
function isElementVisible(element)
{
    var style = window.getComputedStyle(element);

    if (style.display === 'none' || style.visibility === 'hidden')
        return false;

    if (element.parentNode && element.parentNode.nodeType === Node.ELEMENT_NODE)
        return isElementVisible(element.parentNode);

    return true;
}

window.validator =
{
    bindInteractiveForm: function (form, options)
    {
        var inputs = form.querySelectorAll("input, select, textarea");
        var submitButton = form.querySelector(":scope button[type='submit']");

        inputs.forEach(input =>
        {
            input.addEventListener("input", function (e)
            {
                validator.validateField(input);
                validator.validateForm(form, options);
            });
        });

        if (!submitButton)
        {
            console.log("Failed to bind interactive form validation: submit button not found.");

            return;
        }

        submitButton.addEventListener("click", async function (e)
        {
            e.preventDefault();

            if (submitButton.getAttribute("data-disabled") === "true")
                return;

            submitButton.setAttribute("data-disabled", "true");

            var isValid = true;
            var firstInvalidInput = null;

            for (var input of inputs)
            {
                var isFieldValid = validator.validateField(input);

                if (isFieldValid)
                    continue;

                if (firstInvalidInput == null)
                    firstInvalidInput = input;

                isValid = false;
            }

            if (!validator.validateForm(form, options))
                isValid = false;

            if (!isValid)
            {
                e.stopPropagation();

                submitButton.removeAttribute("data-disabled");

                if (firstInvalidInput)
                {
                    firstInvalidInput.scrollIntoView({ behavior: "smooth", block: "center" });

                    setTimeout(() => firstInvalidInput.focus(), 500);
                }

                return;
            }

            if (form.dataset.api === "true")
                await submitApiForm(form);
            else if (form.dataset.ajax === "true")
                await submitAjaxForm(form);
            else
                await submitStandardForm(form);

            submitButton.removeAttribute("data-disabled");
        });

        validator.validateForm(form, options);
    },
    compareInput(input, target)
    {
        return input.value === target.value;
    },
    getInputErrorMessage: function (input)
    {
        if (input.validity.valueMissing)
            return input.dataset.required;

        if (input.validity.patternMismatch)
        {
            if (input.dataset.email)
                return input.dataset.email;

            if (input.dataset.phone)
                return input.dataset.phone;

            if (input.dataset.regex)
                return input.dataset.regex;
        }

        if (input.validity.typeMismatch)
        {
            if (input.dataset.email)
                return input.dataset.email;

            if (input.dataset.url)
                return input.dataset.url;
        }

        if (input.validity.tooShort)
            return input.dataset.minlength;

        if (input.validity.tooLong)
            return input.dataset.maxlength;

        if (input.validity.rangeUnderflow || input.validity.rangeOverflow)
            return input.dataset.range;

        if (input.dataset.regexExpr && input.value.length !== 0)
            return input.dataset.regex;

        if (input.dataset.compare)
            return input.dataset.compare;

        if (input.dataset.requiredWhen && input.dataset.requiredWhenValid !== "true")
            return input.dataset.requiredWhen;

        // Password validation error messages
        if (input.dataset.requireDigit && input.dataset.requireDigitValid !== "true")
            return input.dataset.requireDigitMessage;

        if (input.dataset.requireLowercase && input.dataset.requireLowercaseValid !== "true")
            return input.dataset.requireLowercaseMessage;

        if (input.dataset.requireUppercase && input.dataset.requireUppercaseValid !== "true")
            return input.dataset.requireUppercaseMessage;

        if (input.dataset.requireNonAlphanumeric && input.dataset.requireNonAlphanumericValid !== "true")
            return input.dataset.requireNonAlphanumericMessage;

        if (input.dataset.requireUniqueChars && input.dataset.requireUniqueCharsValid !== "true")
            return input.dataset.requireUniqueCharsMessage;

        // Post code (country-aware) error message
        if (input.dataset.postcodeMessage && input.dataset.postcodeValid === "false")
            return input.dataset.postcodeMessage;

        return null;
    },
    resetForm: function (form)
    {
        if (form.getAttribute("data-interactive") !== "true")
            return;

        var inputs = form.querySelectorAll("input, select, textarea");

        inputs.forEach(input =>
        {
            input.classList.remove("is-invalid");
            input.classList.remove("is-valid");

            var help = input.parentNode.querySelector(":scope .field-validation-valid");

            if (help)
                help.classList.add("d-none");
        });
    },
    validateForm: function (form, options, force)
    {
        var submitButton = form.querySelector(":scope button[type='submit']");

        if (!submitButton)
            return false;

        var disableButton = false;

        if (options !== null)
        {
            if (options.disableButton === true)
                disableButton = true;
        }

        var isValid = form.checkValidity();

        if (disableButton && !isValid)
            submitButton.disabled = true;
        else if (disableButton && isValid)
            submitButton.disabled = false;

        return isValid;
    },
    validateField: function (input)
    {
        if (input.type === "hidden" || !isElementVisible(input) || input.type === "checkbox" && !input.required)
            return true;

        var help = input.parentNode.querySelector(":scope .field-validation-valid");

        var isDisabledUI = input.dataset.disableUi === "true";
        var isValid = input.validity.valid;

        if (input.dataset.compareTarget)
        {
            var target = input.form.querySelector(":scope *[name='" + input.dataset.compareTarget + "']");

            isValid = isValid && validator.compareInput(input, target);
        }

        if (input.dataset.regexExpr)
            isValid = isValid && validator.validateRegexExpression(input, input.dataset.regexExpr);

        if (input.dataset.requiredWhenTarget)
        {
            isValid = isValid && validator.validateRequiredWhen(input, input.dataset.requiredWhenTarget);

            input.dataset.requiredWhenValid = isValid ? "true" : "false";
        }

        // Password validation
        if (input.type === "password")
            isValid = isValid && validator.validatePassword(input);

        // Country-aware post code validation
        if (input.dataset.postcodeCountryTarget)
            isValid = isValid && validator.validatePostCode(input);

        if (isDisabledUI)
            return isValid;

        if (isValid)
        {
            input.classList.remove("is-invalid");
            input.classList.add("is-valid");

            if (help && help.dataset.validMessage)
            {
                help.classList.remove("invalid-tooltip");
                help.classList.add("valid-tooltip");
                help.classList.remove("d-none");
            }
            else if (help)
            {
                help.classList.remove("valid-tooltip");
                help.classList.remove("invalid-tooltip");
                help.classList.add("d-none");
            }
        }
        else
        {
            input.classList.remove("is-valid");
            input.classList.add("is-invalid");

            var errorMessage = validator.getInputErrorMessage(input);

            if (help)
                help.classList.remove("valid-tooltip");

            if (help && errorMessage)
            {
                help.classList.remove("d-none");
                help.classList.add("invalid-tooltip");

                help.innerHTML = errorMessage;
            }
        }

        return isValid;
    },
    validateRegexExpression: function (input, pattern)
    {
        if (input.value.length === 0)
            return true;

        var regex = new RegExp(pattern);

        return regex.test(input.value);
    },
    validateRequiredWhen: function (input, target)
    {
        var targetElement = document.querySelector(`*[name="${target}"]`);

        if (targetElement === null)
            return true;

        // pokud je checkbox tak je vyžadován vždy pokud je objekt viditelný
        if (targetElement.type === "checkbox" && input.value.trim() !== "")
            return true;

        // pokud je target vyplněný a input také tak je valid
        if (targetElement.value.trim() !== "" && input.value.trim() !== "")
            return true;

        // pokud je target prázdný tak není vyžadováno vyplnění inputu
        if (targetElement.value.trim() === "")
            return true;

        return false;
    },
    validatePassword: function (input) // PasswordValidator implementace v JS
    {
        var password = input.value || "";

        var overallValid = true;

        // If password is empty, let HTML5 validation handle required field
        if (password.length === 0)
        {
            // Reset all password validation attributes when empty
            input.dataset.requireDigitValid = "true";
            input.dataset.requireLowercaseValid = "true";
            input.dataset.requireUppercaseValid = "true";
            input.dataset.requireNonAlphanumericValid = "true";
            input.dataset.requireUniqueCharsValid = "true";

            return true;
        }

        // Check digit requirement
        if (input.dataset.requireDigit === "true")
        {
            var digitValid = validator.passwordContainsDigit(password);

            input.dataset.requireDigitValid = digitValid ? "true" : "false";

            if (!digitValid)
                overallValid = false;
        }

        // Check lowercase requirement
        if (input.dataset.requireLowercase === "true")
        {
            var lowercaseValid = validator.passwordContainsLowercase(password);

            input.dataset.requireLowercaseValid = lowercaseValid ? "true" : "false";

            if (!lowercaseValid)
                overallValid = false;
        }

        // Check uppercase requirement
        if (input.dataset.requireUppercase === "true")
        {
            var uppercaseValid = validator.passwordContainsUppercase(password);

            input.dataset.requireUppercaseValid = uppercaseValid ? "true" : "false";

            if (!uppercaseValid)
                overallValid = false;
        }

        // Check non-alphanumeric requirement
        if (input.dataset.requireNonAlphanumeric === "true")
        {
            var nonAlphanumericValid = validator.passwordContainsNonAlphanumeric(password);

            input.dataset.requireNonAlphanumericValid = nonAlphanumericValid ? "true" : "false";

            if (!nonAlphanumericValid)
                overallValid = false;
        }

        if (input.dataset.requireUniqueChars)
        {
            var uniqueCharsValid = validator.passwordContainsUniqueChars(password, input.dataset.requireUniqueChars);

            input.dataset.requireUniqueCharsValid = uniqueCharsValid ? "true" : "false";

            if (!uniqueCharsValid)
                overallValid = false;
        }

        // Post code (country-aware) error message
        if (input.dataset.postcodeMessage && input.dataset.postcodeValid === "false")
            return input.dataset.postcodeMessage;

        return overallValid;
    },
    validatePostCode: function (input)
    {
        // If nothing to validate or empty value, leave to [Required]/server-side
        var value = (input.value || "").trim();

        if (value.length === 0)
        {
            input.dataset.postcodeValid = "true";

            return true;
        }

        var config = window.ABRA || {};
        //var defaultIso = (config.defaultCountry || "CZ").toUpperCase().trim();
        var patterns = config.postCode || {};

        var countryProp = input.dataset.postcodeCountryTarget || "CountryId";
        var form = input.closest("form");

        var defaultIso = (input.dataset.countryId || "").trim();

        if (/^[A-Za-z]{2,3}$/.test(defaultIso))
            defaultIso = defaultIso.toUpperCase();
        else if (defaultIso && patterns[defaultIso])
            defaultIso = defaultIso; // allow mapped keys present in patterns
        else
            defaultIso = ""; // no default

        var iso = "";

        if (form)
        {
            // Try exact name, then nested model (ends with .CountryId)
            var countryInput = form.querySelector(`*[name="${countryProp}"]`)
                || form.querySelector(`*[name$=".${countryProp}"]`);

            if (countryInput)
            {
                var raw = (countryInput.value || "").trim();

                if (/^[A-Za-z]{2,3}$/.test(raw))
                    iso = raw.toUpperCase();
                else if (patterns[raw])
                    iso = raw;

                // Revalidate postcode when country changes
                if (countryInput.dataset.postcodeWatcher !== "true")
                {
                    var rerun = function ()
                    {
                        validator.validateField(input);
                    };

                    countryInput.addEventListener("change", rerun);
                    countryInput.addEventListener("input", rerun);
                    countryInput.dataset.postcodeWatcher = "true";
                }
            }
        }

        // If not resolved from the form, fallback to data-country-id on the input
        if (!iso && defaultIso)
            iso = defaultIso;

        // If we still don't have ISO or we don't have a pattern for it, treat as valid (nothing to check against)
        if (!iso || !(patterns[iso] instanceof RegExp))
        {
            input.dataset.postcodeValid = "true";

            return true;
        }

        var ok = patterns[iso].test(value);

        input.dataset.postcodeValid = ok
            ? "true"
            : "false";

        return ok;
    },
    // Helper methods for password validation (matching ASP.NET Core implementation)
    passwordContainsDigit: function (password)
    {
        for (var i = 0; i < password.length; i++)
        {
            var c = password.charAt(i);

            if (c >= '0' && c <= '9')
                return true;
        }

        return false;
    },
    passwordContainsLowercase: function (password)
    {
        for (var i = 0; i < password.length; i++)
        {
            var c = password.charAt(i);

            if (c >= 'a' && c <= 'z')
                return true;
        }

        return false;
    },
    passwordContainsUppercase: function (password)
    {
        for (var i = 0; i < password.length; i++)
        {
            var c = password.charAt(i);

            if (c >= 'A' && c <= 'Z')
                return true;
        }

        return false;
    },
    passwordContainsNonAlphanumeric: function (password)
    {
        for (var i = 0; i < password.length; i++)
        {
            var c = password.charAt(i);

            if (!((c >= 'A' && c <= 'Z') || (c >= 'a' && c <= 'z') || (c >= '0' && c <= '9')))
                return true;
        }

        return false;
    },
    passwordContainsUniqueChars: function (password, count)
    {
        const array = Array.from(new Set(password))

        if (array.length > parseInt(count))
            return true;

        return false;
    }
};